import React, { ReactNode } from "react";

import "./textField.css";

interface TextFieldWrapperProps {
    label: string;
    labelRight?: ReactNode;
    children: any;
    className?: string;
    info?: string;
    border?: boolean;
}

export default function TextFieldWrapper(props: TextFieldWrapperProps) {
    return <div className={"txoria-text-field" + (props.className ? " " + props.className : "") + (props.border ? " border" : "")}>
        <label>{props.label}{props.info ? <span>{props.info}</span> : <></>}{props.labelRight && <span className="label-right">{props.labelRight}</span>}</label>
        <div className="text-field-content">
            {props.children}
        </div>
    </div>;
}